import { Component, Inject, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import moment from 'moment';
import { Subject, filter } from 'rxjs';
import { AccountService } from 'app/core';
import { User } from 'app/core/models/user.types';
import { ProjectsService } from 'app/modules/projects/projects.service';
import { ProjectType, PropertyType, ProjectStage, InvestmentType, Vehicle } from 'app/core/models/account.types';
import { ConfirmService } from 'app/shared/components/widgets/dialog/confirm/confirm.service';

@Component({
  selector: 'projects-filter',
  templateUrl: './projects-filter.component.html',
  styleUrls: ['./projects-filter.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProjectsFilterComponent implements OnInit {
  filterForm: UntypedFormGroup;

  projectTypes: ProjectType[];
  propertyTypes: PropertyType[];
  projectStages: ProjectStage[];
  vehicles: Vehicle[];
  investmentTypes: InvestmentType[];
  users: User[];

  savedFilter: any = null;

  public isMapView: boolean = false;
  private _unsubscribeAll: Subject<void>;

  /**
   * Constructor
   *
   * @param {MatDialogRef} matDialogRef
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<ProjectsFilterComponent>,
    private _formBuilder: UntypedFormBuilder,
    private _changeDetectorRef: ChangeDetectorRef,
    private _projectsService: ProjectsService,
    private _activatedRoute: ActivatedRoute,
    private _accountService: AccountService,
    private confirmService: ConfirmService,
  ) {
    this._unsubscribeAll = new Subject();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Create the form
    this.filterForm = this._formBuilder.group({
      propertyTypeIdIn: [''],
      projectTypeIdIn: [''],
      vehicleIdIn: [''],
      assignedUserIdIn: [''],
      investmentTypeIdIn: [''],
      projectStageIdIn: [''],
      createdAtGteq: [''],
      createdAtLteq: [''],
      city: [''],
      marketNameCont: [''],
      zip: [''],
      state: [''],
    });

    this.projectTypes = this.data.data.options.project_types.filter((option) => !option.hidden);
    this.propertyTypes = this.data.data.options.property_types.filter((option) => !option.hidden);
    this.projectStages = this.data.data.options.project_stages.filter((option) => !option.hidden);
    this.investmentTypes = this.data.data.options.investment_types.filter((option) => !option.hidden);
    this.vehicles = this.data.data.options.vehicles.filter((option) => !option.hidden);
    this.users = this.data.data.options.users;
    this.isMapView = this.data.isMapView;

    if (this.data.filters) {
      this.filterForm.patchValue(this.data.filters);

      if (this.data.filters.createdAtGteq) {
        this.filterForm.get('createdAtGteq').setValue(moment(this.data.filters.createdAtGteq));
      }
      if (this.data.filters.createdAtLteq) {
        this.filterForm.get('createdAtLteq').setValue(moment(this.data.filters.createdAtLteq));
      }
    }

    if (this.data.savedFilter) {
      this.savedFilter = this.data.savedFilter;
    } else {
      this.savedFilter = { name: '' };
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  setAddress(addressString) {
    //this.projectForm.get('deal').get('property').get('address').get('address_string').setValue(addressString);
  }

  /**
   * Discard the message
   */
  discard(): void {
    this.matDialogRef.close();
  }

  deleteSavedFilter(): void {
    this.confirmService
      .openConfirmationModal()
      .pipe(filter((res: boolean) => res))
      .subscribe(() => {
        this._accountService.deleteFilter(this.savedFilter.id).subscribe((savedFilter) => {
          this.matDialogRef.close();
        });
      });
  }

  /**
   * Send the message
   */
  save(): void {
    let filters = this.filterForm.value;
    if (this.filterForm.get('createdAtGteq').value) {
      filters.createdAtGteq = moment(this.filterForm.get('createdAtGteq').value.toString()).format('YYYY-MM-DD');
    }
    if (this.filterForm.get('createdAtLteq').value) {
      filters.createdAtLteq = moment(this.filterForm.get('createdAtLteq').value.toString()).format('YYYY-MM-DD');
    }

    //check if saved filter to update
    if (this.savedFilter && this.savedFilter.name.length > 0) {
      this.savedFilter.filters = JSON.stringify(filters);

      if (!this.savedFilter.id) {
        this._accountService.saveFilter(this.savedFilter).subscribe((savedFilter) => {
          this.matDialogRef.close({ filters: filters });
        });
      } else {
        //project.pipeline_id = this._projectsService.pipelineId;
        this._accountService.updateFilter(this.savedFilter).subscribe((savedFilter) => {
          this.matDialogRef.close({ filters: filters });
        });
      }
    } else {
      this.matDialogRef.close({ filters: filters });
    }

    //close filter

    //project.pipeline_id = this._projectsService.pipelineId;
  }
}
